import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import React, { Component } from 'react';
import Scriba from 'react-scriba';
import { DataReservation } from '../../data/DataReservation';
import { MaxLengths } from '../../data/MaxLenghts';
import { Immocom } from '../../specifique/immocom';
import { EUIComboBox } from '../EUI/EUIComboBox';
import { EUIDatePicker } from '../EUI/EUIDatePicker';
import { EUITextField } from '../EUI/EUITextField';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

/****************************************************************
 PROPS:
    idOperation
    idReservation
    peutModifierBlocDepotGarantie
    peutAjouterBlocDepotGarantie

    onAffichePanelDepotGarantie : bool

    onEnregistrementFiche : méthode
    onAnnuleFiche : méthode
    
    classname : classe CSS (string)
    classnameinner : classe CSS (string)
****************************************************************/

var objetState = {
    reservation: {},

    enCoursDeTraitement: false,
    messageEnCoursTraitement: '',

    hideMessageBarError: true,
    errorMessage: '',
    hideMessageBarWarning: true,
    warningMessage: '',

    titrePanelDepotGarantie: 'Ajouter un dépôt de garantie',

    onActiveBoutonEnregistrer: false,
};

export class FicheDepotGarantie extends Component {
    _creationContent() {
        return (
            <Panel
                isOpen={this.props.onAffichePanelDepotGarantie}
                headerText={this.state.titrePanelDepotGarantie}
                type={PanelType.medium}
                onDismiss={() => this._onAnnulation()}
                onOpen={() => this._onOpen()}
                closeButtonAriaLabel="Fermer"
                onRenderFooterContent={this._onRenderFooterContent}
            >
                <div className={this.props.classname}>
                    <div className={this.props.classnameinner}>
                        <div className="ms-Grid" dir="ltr">
                            <MessageBars
                                errorMessage={this.state.errorMessage}
                                warningMessage={this.state.warningMessage}
                                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                            />

                            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12" name="divModePaiement">
                                    <EUIComboBox
                                        label="Mode de paiement"
                                        onChange={(event, option) => this._onChangeDGType(option.key || null)}
                                        options={[
                                            { key: "Virement", text: "Virement" },
                                            { key: "Chèque", text: "Chèque" }
                                        ]}
                                        selectedKey={this.state.reservation.dgType}
                                    />
                                </div>
                                {this.state.reservation.dgType === 'Chèque' ?
                                    <div className="ms-Grid-row">
                                        <div className="ms-Grid-col ms-sm12">
                                            <div className="ms-Grid-col ms-sm12 ms-md4">
                                                <EUITextField
                                                    label="Banque"
                                                    maxLength={MaxLengths.reservation.dgNomBanque_Cheque}
                                                    onChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "reservation", "dgNomBanque_Cheque", newValue)}
                                                    value={this.state.reservation.dgNomBanque_Cheque}
                                                />
                                            </div>
                                            <div className="ms-Grid-col ms-sm12 ms-md4">
                                                <EUITextField
                                                    label="N° chèque"
                                                    maxLength={MaxLengths.reservation.dgNumChequeClient_Cheque}
                                                    onChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "reservation", "dgNumChequeClient_Cheque", newValue)}
                                                    value={this.state.reservation.dgNumChequeClient_Cheque}
                                                />
                                            </div>
                                            <div className="ms-Grid-col ms-sm12 ms-md4">
                                                <EUITextField
                                                    label="N° compte"
                                                    maxLength={MaxLengths.reservation.dgNumCompte_Cheque}
                                                    onChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "reservation", "dgNumCompte_Cheque", newValue)}
                                                    value={this.state.reservation.dgNumCompte_Cheque}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    : null
                                }
                                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg6" name="divMontant">
                                    <TextField // Note KP : TextFieldNombre en cours de test
                                        label="Montant"
                                        value={Scriba.officeUI().textField().nombre().ValeurChampNombreObjetAvecPrecisionAfficheeSpecifiee(this, 'reservation', 'dgMontant', false, 2)}
                                        onFocus={() => Scriba.officeUI().textField().nombre().onFocusTextFieldNombreObjet(this, 'reservation', 'dgMontant')}
                                        onBlur={e => Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, 'reservation', 'dgMontant', e.target.value, 'fr', this._onVerificationFormulaire)}
                                        onGetErrorMessage={e => Scriba.officeUI().textField().nombre().onGetErrorMessageTextFieldNombre(this, 'dgMontant', e, false, 2)}
                                        deferredValidationTime={0}
                                        suffix="€"
                                    />
                                </div>
                                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg6" name="divEncaissement">
                                    <EUIDatePicker
                                        label="Date encaissement"
                                        onSelectDate={date => this._onSelectDate(date, 'dgDateEnregistrement')}
                                        value={this.state.reservation.dgDateEnregistrement}
                                    />
                                </div>
                                <div className="ms-Grid-col ms-sm12" name="divEtat">
                                    <EUIComboBox
                                        label="Etat"
                                        onChange={(event, option) => Scriba.state().setObjetPropriete(this, "reservation", "dgSituation", option.key || null)}
                                        options={[
                                            { key: 'Eiffage et conservé', text: 'Eiffage et conservé' },
                                            { key: 'Notaire et conservé', text: 'Notaire et conservé' },
                                            { key: 'Notaire et encaissé', text: 'Notaire et encaissé' }
                                        ]}
                                        selectedKey={this.state.reservation.dgSituation}
                                    />
                                </div>
                                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg6" name="divMontantRestitue">
                                    <TextField // Note KP : TextFieldNombre en cours de test
                                        label="Montant restitué"
                                        value={Scriba.officeUI().textField().nombre().ValeurChampNombreObjetAvecPrecisionAfficheeSpecifiee(this, 'reservation', 'dgMontantRestitue', false, 2)}
                                        onFocus={() => Scriba.officeUI().textField().nombre().onFocusTextFieldNombreObjet(this, 'reservation', 'dgMontantRestitue')}
                                        onBlur={e => Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, 'reservation', 'dgMontantRestitue', e.target.value, 'fr', this._onVerificationFormulaire)}
                                        onGetErrorMessage={e => Scriba.officeUI().textField().nombre().onGetErrorMessageTextFieldNombre(this, 'dgMontantRestitue', e, false, 2)}
                                        deferredValidationTime={0}
                                        suffix="€"
                                    />
                                </div>
                                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg6" name="divDateRestitue">
                                    <EUIDatePicker
                                        label="Date restitution"
                                        onSelectDate={date => this._onSelectDate(date, 'dgDateRestitution')}
                                        value={this.state.reservation.dgDateRestitution}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Panel>
        );
    }

    constructor(props) {
        super(props);

        this.state = objetState;
    }

    _onInit() {
        this.setState(objetState);
    }

    _onChargement() {
        let idReservationRenseigneeEtDifferent = Immocom.getSiPropsRenseigneeEtDifferenteDeLaValeurEnParametre(this.props.idReservation, [0, this.state.idReservation]);
        let idOperationRenseigneeEtDifferent = Immocom.getSiPropsRenseigneeEtDifferenteDeLaValeurEnParametre(this.props.idOperation, [0, this.state.idOperation]);

        if (idReservationRenseigneeEtDifferent && idOperationRenseigneeEtDifferent) {
            this._chargementDonnees();
        }
    }

    _chargementDonnees() {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement du dépôt de garantie'
        });

        var ficheReservation_Simple = DataReservation._ficheReservation_Simple(this.props.idOperation, this.props.idReservation);

        ficheReservation_Simple
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;

                    let stateTemp = {};
                    stateTemp.idReservation = this.props.idReservation;
                    stateTemp.idOperation = this.props.idOperation;
                    stateTemp.reservation = objetData[0];

                    //stateTemp.peutModifierBlocDepotGarantie = this.props.peutModifierBlocDepotGarantie;

                    stateTemp.titrePanelDepotGarantie = 'Modifier le dépôt de garantie';

                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);

                    this._onVerificationFormulaire();
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    //_validationFormulaire(item) {
    //    let estValide = true;

    //    // Si l'objet n'est pas vide
    //    if (!(Object.keys(item).length === 0 && item.constructor === Object)) {
    //        estValide =
    //            (item.idReservation !== 0 & item.idReservation !== null & this.props.peutModifierBlocDepotGarantie) |
    //            ((item.idReservation === 0 | item.idReservation === null) & this.props.peutAjouterBlocDepotGarantie);

    //        estValide = estValide && (Scriba.officeUI().textField().nombre().controleNombreDecimal(item.dgMontant, false, 2) === '');
    //        estValide = estValide && (Scriba.officeUI().textField().nombre().controleNombreDecimal(item.dgMontantRestitue, false, 2) === '');
    //    }
    //    else {
    //        estValide = false;
    //    }

    //    return estValide;
    //}

    _onEnregistrement = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Enregistrement du dépôt de garantie en cours'
        });

        let miseAJourReservation = DataReservation._miseAJourReservation(this.props.idOperation, this.props.idReservation, this.state.reservation);

        miseAJourReservation
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;

                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { ...this.state });

                    this.props.onEnregistrementFiche(objetData);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onAnnulation = () => {
        this._onInit();
        this.props.onAnnuleFiche();
    }

    _onVerificationFormulaire() {
        Immocom.fiche()._validationFormulaire(this, 'DepotGarantieReservation', this.state.reservation, (this.state.reservation.idReservation > 0 ? 'Modification' : 'Création'));
    }

    _onRenderFooterContent = () => {
        return (
            <div>
                <PrimaryButton name="btnEnregistrerGarantie" onClick={() => this._onEnregistrement()} className="marginRight8px" disabled={!this.state.onActiveBoutonEnregistrer}>Enregistrer</PrimaryButton>
                <DefaultButton onClick={() => this._onAnnulation()}>Annuler</DefaultButton>
            </div>
        );
    };

    _onSelectDate(value, champ) {
        var valeurDate = Scriba.date().getChaineISOFromDate(value, true);
        Scriba.state().setObjetPropriete(this, 'reservation', champ, valeurDate);
    }

    _onChangeDGType = (key) => {
        let reservationTrav = { ...this.state.reservation };

        if (key !== 'Chèque') {
            reservationTrav.dgNomBanque_Cheque = null;
            reservationTrav.dgNumChequeClient_Cheque = null;
            reservationTrav.dgNumCompte_Cheque = null;
        }

        reservationTrav.dgType = key;

        this.setState({ reservation: reservationTrav });
    }

    _onOpen = () => {
        if (!this.state.enCoursDeTraitement)
            this._onChargement();
    }

    componentDidMount() { }

    componentWillUnmount() { }

    componentDidUpdate() { }

    render() {
        return this._creationContent();
    }
}